<div class="z-modal-backdrop"
     (mousedown)="onBackdropPress($event)"
     (click)="onBackdropClick($event)">

  <div #dialog
       class="z-modal"
       [class.z-modal--wide]="wide"
       role="dialog"
       aria-modal="true"
       [attr.aria-labelledby]="titleId"
       tabindex="-1">

    <div class="z-modal-header">
      <span class="z-modal-title" [id]="titleId">{{ title }}</span>
      <button class="z-modal-close" type="button" (click)="close()" aria-label="Cerrar">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="z-modal-body">
      <ng-content></ng-content>
    </div>

    <div class="z-modal-footer">
      <!-- Accion secundaria: el boton de cristal es el unico de la familia .z-btn
           que llega a 4.5:1 en los dos temas. El azul claro --z-blue-2 con texto
           blanco se queda en 2.08:1. -->
      <button class="z-btn z-btn--glass" type="button" (click)="close()">Cerrar</button>
    </div>

  </div>
</div>
